module.exports = __webpack_public_path__ + "static/developerIcon-6ddc51e15dd4197cccc8c0b93517e845.svg";